<template>
  <div class="header">
    <p class="title">{{ title }}</p>
    <p class="sub-title">
      {{ subTitle }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'OverlayProductHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss' as old-variables;

.header {
  background-color: old-variables.$color-grey-darker;
  color: #fff;
  position: relative;
  padding: 20px;
  height: 100px;
}

.title {
  color: #fff;
  font-size: 26px;
  font-weight: bold;
  margin: 0;
}
.sub-title {
  color: #fff;
  font-weight: 600;
  font-size: 18px;
  margin: 0;
}
</style>
